<template>
  <div  class="tinymce-editor">
    <editor :init="tinymceInit" v-model="myValue" :disabled="disabled" @onClick="onClick" :placeholder="placeholder" :id="tinymceId"></editor>
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/icons/default/icons'
import 'tinymce/icons/default/icons.min.js'
import 'tinymce/plugins/image' // 插入上传图片插件
import { isIos } from '@/utils/common';

export default {
  name: 'TinymceEditor',
  components: {
    editor: Editor
  },
  props: {
    id: {
      type: String,
      default: () => {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'advlist table lists paste preview fullscreen code image media autoresize codesample'
    },
    toolbar: {
      type: [Array, String],
      default: '',
    },
    placeholder: {//占位符文字
      type: String,
      default: ''
    },
    editHtml: {
      type: String,
      required: false
    },
    height: {
      type: String,
      default: '150'
    },
    pasteFlag: {
      type: Boolean,
      default: false
    },
    noPasting: {
      type: Boolean,
      default: false
    }
  },
   emits: ["update:value"],
  data() {
    const _this = this
    return {
      tinymceInit: {
        selector: `#${this.tinymceId}`,
        height: this.height,
        relative_urls: true,
        min_height: 160,
        autoresize_bottom_margin: 0,
        document_base_url: '/public/',
        skin_url: '/tinymce/skins/ui/oxide',
        content_css: '/tinymce/skins/content/default/content.min.css',
        language_url: '/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        browser_spellcheck: true, // 拼写检查
        branding: false, // 去水印
        // elementpath: false,  //禁用编辑器底部的状态栏
        statusbar: false, // 隐藏编辑器底部的状态栏
        paste_data_images: true, // 允许粘贴图像
        menubar: false, // 隐藏最上方menu
        plugins: '',
        toolbar: this.toolbar,
        media_live_embeds: true,
        content_style: 'img {max-width:100%;}', // 图片太大时, 在编辑器内的限制图片大小
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        font_formats:
          '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',
        //external_plugins: { tiny_mce_wiris: '/tinymce/plugin.min.js' }
        // contextmenu: ' ', //右键菜单
        images_upload_handler: (blobInfo, success, failure) => {
          if (blobInfo.blob().size > 5242880) {
            return failure('图片文件不能大于 5MB');
          }
          const formData = new FormData()
          formData.append('file', blobInfo.blob(), blobInfo.filename())
          this.loading = true
          publicApis.editorUpload(formData).then(res => {
            if(typeof(res)=='string'){
              success(res)
            }else{
              success(res['src'])
            }
            setTimeout(()=>{
             this.loading = false
            },500)
          }).catch(()=>{})
        },
        setup(editor) {
            editor.on('focusin',()=>{
              // console.log('键盘弹起')
             })
            if (isIos) { //如果ios判断键盘收起
             editor.on('focusout',()=>{
              // console.log('键盘收起')
              _this.$emit('blur', tinymce.activeEditor.getContent())
              _this.$emit('update:value', tinymce.activeEditor.getContent())
              })
            }else{
             editor.on('blur',()=>{
              _this.$emit('blur', tinymce.activeEditor.getContent())
              _this.$emit('update:value', tinymce.activeEditor.getContent())
              })
            }
          editor.ui.registry.addButton('exportWord', {
            text: '清空文本',
            icon: 'new-document',
            onAction: () => {
             editor.setContent('')
            }
          })
        },
      },
      myValue: this.value,
      loading: false,
      fileList: [],
      tinymceId: this.id
    }
  },
  created() {},
  watch: {
    value(newValue) {
      this.myValue = newValue
    },
  },
  methods: {
    onClick(e) {
        if (e.fromElement != null && e.fromElement.getAttribute('data-tip-info')) {
        this.myValue = ''
      }
    },
    // 清空内容
    clear() {
      this.myValue = ''
    },
    // 获取编辑器内容
    getContent() {
      this.$emit('reqSaveTemplate', tinymce.activeEditor.getContent())
      return tinymce.activeEditor.getContent()
    },
    // 插入参数html
    insertHtml(id, name) {
      const html = `&nbsp;<span id=${id} data-ecloudsign-value=${name} style='background: #689df6;cursor: pointer;color: #fff;' >${name}</span>&nbsp;`
      tinymce.activeEditor.insertContent(html)
    },

    getRandom(length) {
      let Num = ''
      for (let i = 0; i < length; i++) {
        Num += Math.floor(Math.random() * 10)
      }
      return Num
    },
    handleSolution(arr) {
      if (!arr || arr.length === 0) return []
      if (arr.length > 0) {
        const temp = arr.filter(item => /^[A-Z]/g.test(item)) // 去除空格
        return temp
      }
    }
  },
  beforeDestory() {
  }
}
</script>

<style lang="scss">
.tox,
.tox-tinymce-aux {
  z-index: 99;
}
.tinymce-editor{
  margin: 14px 0;
}
</style>
